<template>
    <div>
        <c-model
            ref="postModelContent"
            title="岗位维护"
            width="50%"
            @confirm="saveInfo()"
        >
            <el-button type="primary" size="small" @click="addItem"
                >增加岗位</el-button
            >

            <el-button type="primary" size="small" @click="$_onBatchAdd"
                >批量添加</el-button
            >

            <el-form ref="postForm" :model="dataList">
                <el-table :data="dataList.rows" class="table-center linkModel">
                    <el-table-column prop="postName" label="岗位名称">
                        <template slot-scope="{ row, $index }">
                            <el-form-item
                                label="岗位名称"
                                :prop="'rows.' + $index + '.name'"
                                hiddenLabel
                                hiddenErrorText
                                required
                            >
                                <el-input v-model="row.name"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="postCode" label="岗位编号">
                        <template slot-scope="{ row, $index }">
                            <el-form-item
                                label="岗位编号"
                                :prop="'rows.' + $index + '.code'"
                                hiddenLabel
                                hiddenErrorText
                                required
                            >
                                <el-input v-model="row.code"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column prop="postNumber" label="招聘人数">
                        <template slot-scope="{ row, $index }">
                            <el-form-item
                                label="招聘人数"
                                :prop="'rows.' + $index + '.total'"
                                hiddenLabel
                                hiddenErrorText
                            >
                                <el-input v-model="row.total"></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="80px">
                        <template slot-scope="{ row, $index }">
                            <div class="actions">
                                <a @click="deleteItem(row, $index)">删除</a>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </c-model>
        <c-model
            title="批量添加岗位"
            ref="batchAddModel"
            @confirm="$_onConfirmBatchAdd"
        >
            <el-input
                type="textarea"
                :rows="6"
                placeholder="以英文逗号进行岗位,编号,人数分隔,例如(客服,01,20);以回车号进行换行"
                v-model="batchPost"
            >
            </el-input>
        </c-model>
    </div>
</template>

<script>
import TableMixin from '@/mixins/TableMixin';
import { recruitRes } from '@/api';
export default {
    mixins: [TableMixin],
    props: {
        data: {
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            dataList: {
                rows: [],
            },
            info: {},
            batchPost: '',
        };
    },
    watch: {
        data(newData) {
            var rows = JSON.parse(JSON.stringify(newData));
            this.dataList = { rows };
        },
    },
    methods: {
        open() {
            this.openModel('postModelContent');
        },
        close() {
            this.closeModel('postModelContent');
        },
        cancel() {
            //点击取消，数据还原
            this.dataList = { rows: this.data };
        },
        saveInfo() {
            this.$refs.postForm.validate((valid) => {
                console.log(valid);
                if (valid) {
                    //判断岗位名称是否重复，判断岗位编号是否重复
                    var { rows } = this.dataList;
                    var flag = false;
                    for (var i = 0, len = rows.length; i < len; i++) {
                        var item1 = rows[i];
                        for (var j = 1; j < len; j++) {
                            var item2 = rows[j];
                            if (i !== j) {
                                if (
                                    item1.name === item2.name ||
                                    item1.code === item2.code
                                ) {
                                    flag = true;
                                    break;
                                }
                            }
                        }
                        if (flag) {
                            break;
                        }
                    }

                    if (flag) {
                        this.$message.error('岗位名称和编号不能重复!');
                        return;
                    }
                    this.$emit('savePost', rows);
                }
            });
        },
        addItem() {
            this.dataList.rows.push({});
        },
        deleteItem(row, index) {
            //判断是否有id，没有id直接移出
            if (!row.id) {
                this.dataList.rows.splice(index, 1);
                return;
            }

            //判断岗位是否能删除(有人报名不能删除)
            recruitRes.postCanEdit({ id: row.id }).then((res) => {
                var { isEdit } = res;
                if (isEdit) {
                    this.dataList.rows.splice(index, 1);
                } else {
                    this.$message.warning('该岗位已有人报名,无法删除');
                }
            });
        },
        /**
         * @description: 批量添加岗位
         * @author: lizi
         */

        $_onBatchAdd() {
            this.openModel('batchAddModel');
        },
        $_onConfirmBatchAdd() {
            if (!this.batchPost) {
                this.$message.error('请输入岗位信息');
                return;
            }
            // 以回车符进行岗位切割
            let postList = [];
            let postRow = this.batchPost.split('\n');
            let hasError = false;
            for (var i in postRow) {
                let row = postRow[i];
                // 逗号分隔岗位信息
                let postDetail = row.split(',');
                let total = postDetail[2];
                if (isNaN(Number(total))) {
                    hasError = true;
                    this.$message.error(`第${+i+1}行岗位人数必须为整数`);
                    break;
                }
                let item = {
                    name: postDetail[0],
                    code: postDetail[1],
                    total,
                };
                postList.push(item);
            }
            if (!hasError) {
                this.dataList.rows = this.dataList.rows.concat(postList);
                this.closeModel('batchAddModel');
                this.batchPost = '';
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.linkModel {
    .el-date-editor.el-input {
        width: 100%;
    }
}
</style>
